export enum SessionCancellationReason {
  OtherParticipantKbaFailed = 'OtherParticipantKbaFailed',
  OwnKbaFailed = 'OwnKbaFailed',
  OwnKbaExpired = 'OwnKbaExpired',
}
